(function () {
  'use strict';

  var CLICK_URL = 'https://cdn.shopify.com/s/files/1/0981/2888/8099/files/click_sound.mp3?v=1775871289';
  var CASH_URL  = 'https://cdn.shopify.com/s/files/1/0981/2888/8099/files/cash_sound.mp3?v=1775871289';
  var DELAY     = 120; // ms between click and cash
  var COOLDOWN  = 300; // ms — prevents spam
  var lastPlay  = 0;
  var unlocked  = false;

  // ── Preload both sounds ──
  var clickAudio = new Audio(CLICK_URL);
  var cashAudio  = new Audio(CASH_URL);

  clickAudio.preload = 'auto';
  cashAudio.preload  = 'auto';
  clickAudio.volume  = 0.35;
  cashAudio.volume   = 0.75;

  // ── Unlock audio on first interaction (iOS/mobile) ──
  function unlock() {
    if (unlocked) return;
    [clickAudio, cashAudio].forEach(function(a) {
      a.play().then(function() {
        a.pause();
        a.currentTime = 0;
      }).catch(function() {});
    });
    unlocked = true;
  }

  // ── Play helper ──
  function play(audio) {
    try {
      var clone = audio.cloneNode();
      clone.volume = audio.volume;
      clone.play().catch(function() {});
    } catch(e) {}
  }

  // ── Find clickable parent ──
  function findClickable(el) {
    var node = el;
    var depth = 0;
    while (node && depth < 5) {
      var tag = node.tagName ? node.tagName.toLowerCase() : '';
      if (tag === 'button' || tag === 'a' || node.getAttribute('role') === 'button') {
        return node;
      }
      node = node.parentElement;
      depth++;
    }
    return null;
  }

  // ── Main listener ──
  document.addEventListener('click', function(e) {
    unlock();

    var target = findClickable(e.target);
    if (!target) return;
    if (target.hasAttribute('data-no-sound')) return;

    var now = Date.now();
    if (now - lastPlay < COOLDOWN) return;
    lastPlay = now;

    // click sound first
    play(clickAudio);

    // cash sound after delay
    setTimeout(function() {
      play(cashAudio);
    }, DELAY);

  }, { passive: true });

})();